<template>
  <div class="noticeDetails-user" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ Privacypolicy.title }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="notice-details">
      <!-- <div class="title">{{ Privacypolicy.title }}</div> -->
      <div class="time" v-html="Privacypolicy.content"></div>
    </div>
  </div>
</template>

<script>
import { article } from '@/utils/request'
import { BASEURL } from '@/utils/http'
export default {
  data() {
    return {
      noticelist: [],
      title: '', //0、用户协议 1、隐私政策  2、关于我们
      Privacypolicy: [],
      height: '', //屏幕高度
      baseUrl: ''
    }
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  created() {
    this.title = this.$route.query.type
    this.article(this.title)
  },
  mounted() {
    this.baseUrl = BASEURL
  },
  methods: {
    article(title) {
      var type = ''
      if (title == 0) {
        type = 'SERVICE'
      } else if (title == 1) {
        type = 'DECLARES'
      } else {
        type = 'ABOUT_US'
      }
      article({
        type: type
      }).then(res => {
        res.data.content = res.data.content.replace(RegExp('<img src="', 'g'), '<img style="max-width:100%;max-height:100%" src="' + this.baseUrl)

        this.Privacypolicy = res.data
        console.log(this.Privacypolicy.content)
      })
    },
    looknotice(item) {
      this.noticelist = JSON.parse(item)
    },
    toBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.noticeDetails-user {
  width: 100vw;
  height: var(--height);
  background: #0c0b0b;
  overflow-y: scroll;

  .notice-details {
    padding: 0 0.9375rem;

    .title {
      font-size: 1rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      padding: 1rem 0 0.3125rem;
    }

    .time {
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      padding-bottom: 1.875rem;
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Privacypolicy.vue